module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Valve.js"));
	}, "Valve");
}